export default __webpack_public_path__ + "static/media/promo-icon-bottom-nav-mobile-active.e529174b.webp";